import { ReactElement, ReactNode } from 'react';
import styles from './styles/FixedBottomButtonContainer.module.scss';

const FixedBottomButtonContainer = ({ children }: { children: ReactNode }): ReactElement => {
  return <div className={styles['fixed-button-container']}>{children}</div>;
};

export default FixedBottomButtonContainer;
